import { render, staticRenderFns } from "./inspections.vue?vue&type=template&id=2b6e2a74&"
import script from "./inspections.vue?vue&type=script&lang=js&"
export * from "./inspections.vue?vue&type=script&lang=js&"
import style0 from "./inspections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "inspections.vue"
export default component.exports